import { ROUTE_BASE_URL } from "../../api/common";


const metisMenu = [
	{
		"id": 'main',
		"label": "Main"
	},
	// {
	// 	"id": 1,
	// 	"icon": "icon-speedometer",
	// 	"label": "Dashboard",
	// 	"to": `${ROUTE_BASE_URL}/dashboard"
	// },
	{
		"id": 2,
		"icon": "fa fa-users",
		"label": "Membership Application",
		"to": `${ROUTE_BASE_URL}/membership-application`,
		content: [
			{
				"id": 21,
				"label": "Application",
				"to": `${ROUTE_BASE_URL}/membership-application`
			},
			{
				"id": 22,
				"label": "Package",
				"to": `${ROUTE_BASE_URL}/member-package`
			}
		]

	},
	{
		"id": 3,
		"icon": "fa fa-user-o",
		"label": "Admin Users",
		"to": `${ROUTE_BASE_URL}/admin-users`,
		content: [
			{
				"id": 31,
				"label": "Users",
				"to": `${ROUTE_BASE_URL}/admin-users`
			},
			{
				"id": 32,
				"label": "Role",
				"to": `${ROUTE_BASE_URL}/admin-user-role`
			}
		]

	},
	{
		"id": 4,
		"icon": "fa fa-file-text-o",
		"label": "Reports",
		"to": `${ROUTE_BASE_URL}/membership-application-reports`,
		content: [
			{
				"id": 41,
				"label": "Application",
				"to": `${ROUTE_BASE_URL}/membership-application-reports`
			},
			{
				"id": 42,
				"label": "Payments",
				"to": `${ROUTE_BASE_URL}/membership-application-payment-reports`
			}
		]

	},
	{
		"id": 5,
		"icon": "icon-layers",
		"label": "Master",
		"to": `${ROUTE_BASE_URL}/`,
		content: [,
			{
				"id": 61,
				"label": "Application Queries",
				"to": `${ROUTE_BASE_URL}/application-queries`
			},
			{
				"id": 60,
				"label": "Push Notification",
				"to": `${ROUTE_BASE_URL}/push-notification`
			},
			{
				"id": 58,
				"label": "Membership Certificate",
				"to": `${ROUTE_BASE_URL}/membership-certificate`
			},
			{
				"id": 59,
				"label": "FMAS Certificate",
				"to": `${ROUTE_BASE_URL}/fmas-certificate`
			},
			{
				"id": 51,
				"label": "GST",
				"to": `${ROUTE_BASE_URL}/gst`
			},
			// {
			// 	"id": 52,
			// 	"label": "GST Type Master",
			// 	"to": `${ROUTE_BASE_URL}/gst-type`
			// },
			{
				"id": 53,
				"label": "Currency",
				"to": `${ROUTE_BASE_URL}/currency`
			},
			{
				"id": 54,
				"label": "Payment Status",
				"to": `${ROUTE_BASE_URL}/payment-status`
			},
			// {
			// 	"id": 55,
			// 	"label": "Review Status Master",
			// 	"to": `${ROUTE_BASE_URL}/review-status`
			// },
			{
				"id": 56,
				"label": "Application Status",
				"to": `${ROUTE_BASE_URL}/application-status`
			},
			{
				"id": 57,
				"label": "Country",
				"to": `${ROUTE_BASE_URL}/country`
			}

		]
	},
	{
		"id": 6,
		"icon": "fa fa-ticket",
		"label": "Events",
		"to": `https://eventz360.amasi.org/events/admin/login`

	},
		// {
	// 	"id": 7,
	// 	"icon": "fa fa-cog",
	// 	"label": "Settings",
	// 	"to": `${ROUTE_BASE_URL}/settings`

	// },
];

export default metisMenu	